import { IOrganization } from "@/api";
import { LinkRouter } from "@/components/shared/buttons/LinkRouter";
import { Typography } from "@mui/material";

interface IProps {
    /**
     * the organization to display the name of
     */
    organization: IOrganization;
}

/**
 * a component that displays the name of an organization
 * and links to the organization details page
 */
export const OrganizationName = ({ organization }: IProps) => {
    return (
        <LinkRouter to={`${organization.id}/details`}>
            <Typography variant="body2" fontWeight={600} color="primary">
                {organization.name}
            </Typography>
        </LinkRouter>
    );
};
